import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventsService } from '../events/events.service';

@Injectable({
  providedIn: 'root',
})
export class SplashService {
  private readonly _eventsServices = inject(EventsService);

  private requestCount = 0;
  private readonly splashScreenRequestPrivate$ = new BehaviorSubject<boolean>(
    false,
  );

  get getSplashScreenRequestObservable(): Observable<boolean> {
    return this.splashScreenRequestPrivate$.asObservable();
  }

  showSplashRequest(): void {
    this.requestCount++;

    if (this.requestCount === 1) {
      this.splashScreenRequestPrivate$.next(true);
      this._eventsServices.handleLoaderShow(true);
    }
  }

  hideSplashRequest(): void {
    this.requestCount--;

    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.splashScreenRequestPrivate$.next(false);
      this._eventsServices.handleLoaderShow(false);
    }
  }
}
